import { IClassGradeSubjectStructureResponse } from '../../apis/institute/institute.interfaces';

export const mockClassGradeSubjectStructure: IClassGradeSubjectStructureResponse = {
  classes: [
    {
      classId: 1,
      className: 'Class 1',
      standardLevel: 'CLASS_1',
      section: 'A',
      subjects: [
        {
          courseId: 1,
          courseName: 'Science',
          subjectCode: 'SCI',
          subjectType: 'core',
        },
        {
          courseId: 2,
          courseName: 'Mathematics',
          subjectCode: 'MATH',
          subjectType: 'core',
        },
        {
          courseId: 3,
          courseName: 'English',
          subjectCode: 'ENG',
          subjectType: 'core',
        },
      ],
    },
    {
      classId: 6,
      className: 'Class 6',
      standardLevel: 'CLASS_6',
      section: 'A',
      subjects: [
        {
          courseId: 1,
          courseName: 'Science',
          subjectCode: 'SCI',
          subjectType: 'core',
        },
        {
          courseId: 2,
          courseName: 'Mathematics',
          subjectCode: 'MATH',
          subjectType: 'core',
        },
        {
          courseId: 3,
          courseName: 'English',
          subjectCode: 'ENG',
          subjectType: 'core',
        },
        {
          courseId: 4,
          courseName: 'Social Studies',
          subjectCode: 'SOC',
          subjectType: 'core',
        },
        {
          courseId: 5,
          courseName: 'Hindi',
          subjectCode: 'HIN',
          subjectType: 'language',
        },
      ],
    },
  ],
};
